export { GameSpeedInfoDialog } from './GameSpeedInfoDialog.tsx';
